import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  AfterViewChecked,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';

import {
  style,
  trigger,
  transition,
  animate
} from '@angular/animations';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { SkyResourcesService } from './../resources/resources.service';

import {
  SkyVerticalTabsetService,
  VISIBLE_STATE
} from './vertical-tabset.service';

import { SkyMediaQueryService } from './../media-queries/media-query.service';


export class SkyVerticalTabsetComponent implements OnInit, AfterViewChecked, OnDestroy {

  
  public showTabsText: string = this.resources.getString('vertical_tabs_show_tabs_text');

  
  public activeChange = new EventEmitter<number>();

  
  public tabGroups: ElementRef;

  
  public content: ElementRef;

  private _ngUnsubscribe = new Subject();

  constructor(
    public tabService: SkyVerticalTabsetService,
    private resources: SkyResourcesService,
    private changeRef: ChangeDetectorRef) {}

  public ngOnInit() {
    this.tabService.indexChanged
      .takeUntil(this._ngUnsubscribe)
      .subscribe((index: any) => {
        this.activeChange.emit(index);
        this.changeRef.markForCheck();
      });

    this.tabService.switchingMobile
      .takeUntil(this._ngUnsubscribe)
      .subscribe((mobile: boolean) => this.changeRef.detectChanges());

    if (this.tabService.isMobile()) {
      this.tabService.animationVisibleState = VISIBLE_STATE;
    }
  }

  public ngAfterViewChecked() {
    this.tabService.content = this.content;
    this.tabService.updateContent();
  }

  public ngOnDestroy() {
    this._ngUnsubscribe.next();
    this._ngUnsubscribe.complete();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-vertical-tabset',
  template: ` <div class="sky-vertical-tabset" (window:resize)="tabService.updateContent()">
  <div 
    #contentWrapper 
    class="sky-vertical-tabset-group-container"
    [@tabGroupEnter]="tabService.animationVisibleState"
    *ngIf="tabService.tabsVisible()"
  >
    <ng-content></ng-content>
  </div> 
  <div 
    class="sky-vertical-tabset-content"
    [@contentEnter]="tabService.animationVisibleState"
    *ngIf="tabService.contentVisible()"
  >
    <div #skySideContent></div>
    <button 
      *ngIf="!tabService.tabsVisible()"
      (click)="tabService.showTabs()"
      class="sky-btn sky-btn-primary sky-vertical-tabset-show-tabs-btn"
    >
      <i class="fa fa-chevron-left"></i>
      {{ showTabsText }}
    </button>
  </div>
</div> 
`,
  styles: [`@media (min-width: 768px) {
  .sky-vertical-tabset {
    display: flex;
    height: 100%;
  }
  .sky-vertical-tabset-group-container {
    border-right: 1px solid #cdcfd2;
  }
}

.sky-vertical-tabset-content {
  margin: 10px 0 0 10px;
  flex-basis: 75%;
  overflow-y: auto;
}

.sky-vertical-tabset-show-tabs-btn {
  margin-top: 10px;
}

.sky-vertical-tabset-group-container {
  flex-basis: 25%;
  overflow-y: auto;
}
`],
  providers: [SkyVerticalTabsetService, SkyResourcesService, SkyMediaQueryService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'tabGroupEnter', [
        transition(`void => ${VISIBLE_STATE}`, [
          style({transform: 'translate(-100%)'}),
          animate('150ms ease-in')
        ])
      ]
    ),
    trigger(
      'contentEnter', [
        transition(`void => ${VISIBLE_STATE}`, [
          style({transform: 'translate(100%)'}),
          animate('150ms ease-in')
        ])
      ]
    )
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyVerticalTabsetService, },
{type: SkyResourcesService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'showTabsText': [{ type: Input },],
'activeChange': [{ type: Output },],
'tabGroups': [{ type: ViewChild, args: ['contentWrapper', ] },],
'content': [{ type: ViewChild, args: ['skySideContent', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
